
import { useEffect, useRef, useState, useCallback } from 'react';
import useWindowDimensions from '../../hooks/getWindowDimensions';

import { useAppSceneContext } from '../SceneState/SceneState';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import lottie from "lottie-web";

import videojs from 'video.js'

import ReactFullpage, { fullpageApi } from '@fullpage/react-fullpage';
import sendPostMessage from '../../sendPostMessage';

import Menu from '../Menu/Menu'
import './MobileView.scss';
import './TabletView.scss';
import './LandscapeView.scss';
import '../../../node_modules/video.js/dist/video-js.css';

gsap.registerPlugin(DrawSVGPlugin, ScrollToPlugin);

function MobileView() {
    const windowDimensions = useWindowDimensions();
    const { gotoScene, setGotoScene, scene, setScene } = useAppSceneContext();
    const [part, setPart] = useState("");
    const [menuClick, setMenuClick] = useState<number>(-1);
    const [goingToPart, setGoingToPart] = useState<number>(-1);
    const [initialLeft, setInitialLeft] = useState<number>(0);
    const [dragStartX, setDragStartX] = useState<number>(0);
    const [leftBound, setLeftBound] = useState<number>(0);
    const [middleBound, setMiddleBound] = useState<number>(0);
    const [menuHeight, setMenuHeight] = useState<number>(0);
    const [marginHeight, setMarginHeight] = useState<number>(0);
    const [clearPauseTimeout, setClearPauseTimeout] = useState<NodeJS.Timeout | null>(null);
    const [activeVideo, setActiveVideo] = useState<videojs.Player | null>(null);
    const [players, setPlayers] = useState<{ player1: videojs.Player, player2: videojs.Player, player3: videojs.Player } | undefined>(undefined);
    const [fullpageapi, setFullpageApi] = useState<fullpageApi | null>(null);
    const nodeRef = useRef<HTMLDivElement>(null);
    const scenesRef = useRef<HTMLDivElement>(null);
    const videoProgress = useRef<gsap.core.Timeline>(gsap.timeline({ useFrames: true, paused: true, repeat: 0, ease: "none" }));


    const playPauseTrigger = useRef<HTMLDivElement>(null);

    const heading = useRef<HTMLHeadingElement>(null);
    const ctalink = useRef<HTMLAnchorElement>(null);
    const ctalinkAni = useRef<HTMLSpanElement>(null);
    const nextScene = useRef<HTMLButtonElement>(null);
    const desk = useRef<HTMLDivElement>(null);
    const book = useRef<HTMLImageElement>(null);
    const act1Player = useRef<HTMLVideoElement>(null);
    const act1Progress = useRef<SVGCircleElement>(null);
    const icons = useRef<HTMLImageElement>(null);
    const clock = useRef<HTMLImageElement>(null);
    const pens = useRef<HTMLImageElement>(null);
    const mug = useRef<HTMLImageElement>(null);
    const plant = useRef<HTMLImageElement>(null);


    const act2Player = useRef<HTMLVideoElement>(null);
    const notebook = useRef<HTMLImageElement>(null);
    const headphones = useRef<HTMLImageElement>(null);
    const act2Progress = useRef<SVGCircleElement>(null);


    const act3Player = useRef<HTMLVideoElement>(null);
    const egg = useRef<HTMLImageElement>(null);
    const tablenumber = useRef<HTMLImageElement>(null);
    const act3Progress = useRef<SVGCircleElement>(null);

    const menuWidth = 584;

    const getScreenClass = useCallback((name: String): string => {
        return name + (windowDimensions.width > 630 ? " limit" : "");
    }, [windowDimensions.width]);

    const getVideo = useCallback((part: string, scene: string): videojs.Player | null => {
        if (scene === "connect") {
            switch (part) {
                case "part1":
                    if (players && players.player1) {
                        players.player1.pause();
                        players.player1.src({
                            src: "https://kstatic.googleusercontent.com/files/671b20728bd41fecfba7033df44c50e43b00a743b852085cc1c5d65dc7b7b120f5431027c155ce0298e1f7208ad6775a89a404a7710d1097c6ab1a9c42eb633b",
                            type: 'video/mp4'
                        });
                        players.player1.load();
                        return players.player1;
                    }
                    return null;
                case "part2":
                    if (players && players.player1) {
                        players.player1.pause();
                        players.player1.src({
                            src: "https://kstatic.googleusercontent.com/files/383002ab54074c90f96a9bb34ea7a29d70bf6928945fcaf834645c5680493ded9ecce0eb170ee847a7aba08b8560a8fa6cf9797ba4f204586152feda2eee3fa9",
                            type: 'video/mp4'
                        });
                        players.player1.load();
                        return players.player1;
                    }
                    return null;
                case "part3":
                    if (players && players.player1) {
                        players.player1.pause();
                        players.player1.src({
                            src: "https://kstatic.googleusercontent.com/files/b3927752e8544a2ba023bc37c9ed976a748aedb51e74a3fc894fb791dea9c97d6d0efe43a3230f47632efb172c01f51e9b2faf61b02a4e146a8e94100c921ceb",
                            type: 'video/mp4'
                        });
                        players.player1.load();
                        return players.player1;
                    }
                    return null;
            }
        } else if (scene === "create") {
            switch (part) {
                case "part1":
                    if (players && players.player2) {
                        players.player2.pause();
                        players.player2.src({
                            src: "https://kstatic.googleusercontent.com/files/daeb06e95c033dfcd2781e6172a04c8292ba2b35a11ef3d4eedcc87815993d2b8df55e23ccdc24865abb836620a76f604661267e94ed739b10bb5b91bbc5af16",
                            type: 'video/mp4'
                        });
                        players.player2.load();
                        return players.player2;
                    }
                    return null;
                case "part2":
                    if (players && players.player2) {
                        players.player2.pause();
                        players.player2.src({
                            src: "https://kstatic.googleusercontent.com/files/ba003e62b3fdf69e098ab10980a817b9dbbe0a21195788b24de5bda266c67decbda5811a9e76396c165cddce04f805111d887e325ce8148c18433783324bc2a5",
                            type: 'video/mp4'
                        });
                        players.player2.load();
                        return players.player2;
                    }
                    return null;
                case "part3":
                    if (players && players.player2) {
                        players.player2.pause();
                        players.player2.src({
                            src: "https://kstatic.googleusercontent.com/files/6a3452e744b6e9fa351d43b225063459f9b5ea97ade262277d71816146dfb89be737fe3cf38261a549970257ea9e4589f78b1506b807491aa25da78609598f58",
                            type: 'video/mp4'
                        });
                        players.player2.load();
                        return players.player2;
                    }
                    return null;
            }
        } else if (scene === "collaborate") {
            switch (part) {
                case "part1":
                    if (players && players.player3) {
                        players.player3.pause();
                        players.player3.src({
                            src: "https://kstatic.googleusercontent.com/files/69e1f1cb133a8bdcc042918ac1390eb8667880da6a4009931435254090c2bb8150634ffbe711d3ee4b5f19ead1059e6ba9eda1ccc0656d0685a1dff340b798cc",
                            type: 'video/mp4'
                        });
                        players.player3.load();
                        return players.player3;
                    }
                    return null;
                case "part2":
                    if (players && players.player3) {
                        players.player3.pause();
                        players.player3.src({
                            src: "https://kstatic.googleusercontent.com/files/ed43c75509d36656ae3969be038390991400005be128d2c158d0b0f33320d8e152e8148ec62e09a5031f0c78944d2dbd9cf7fdc828e9be509a0eabc692b8c588",
                            type: 'video/mp4'
                        });
                        players.player3.load();
                        return players.player3;
                    }
                    return null;
                case "part3":
                    if (players && players.player3) {
                        players.player3.pause();
                        players.player3.src({
                            src: "https://kstatic.googleusercontent.com/files/cd541caf4a3d3a11a53f71380148d7d11bd58d379f8ccebcc80119e6d741c2ec7cfcc9af564bdece5205839e26c9af832dd4bc87d075cd8ab7989d991e9610cc",
                            type: 'video/mp4'
                        });
                        players.player3.load();
                        return players.player3;
                    }
                    return null;
            }
        }
        return null;
    }, [players]);

    const trackVideoChange = (part: string, scene: string, type: string) => {
        if (scene === "connect") {
            switch (part) {
                case "part1":
                    sendPostMessage("Google workspace demo mobile: interaction", "Connect with your team : Connect distributed teams", type);
                    return;
                case "part2":
                    sendPostMessage("Google workspace demo mobile: interaction", "Connect with your team : Empower everyone to contribute", type);

                    return;
                case "part3":
                    sendPostMessage("Google workspace demo mobile: interaction", "Connect with your team : Get on the same page", type);
                    return;
            }
        } else if (scene === "create") {
            switch (part) {
                case "part1":
                    sendPostMessage("Google workspace demo mobile: interaction", "Create in real time: Share rich content remotely", type);
                    return;
                case "part2":
                    sendPostMessage("Google workspace demo mobile: interaction", "Create in real time: Give everyone a voice", type);
                    return;
                case "part3":
                    sendPostMessage("Google workspace demo mobile: interaction", "Create in real time : Organize next steps", type);
                    return;
            }
        } else if (scene === "collaborate") {
            switch (part) {
                case "part1":
                    sendPostMessage("Google workspace demo mobile: interaction", "Collaborate from anywhere : Stay on task across devices", type);
                    return;
                case "part2":
                    sendPostMessage("Google workspace demo mobile: interaction", "Collaborate from anywhere : Work with all file types", type);
                    return;
                case "part3":
                    sendPostMessage("Google workspace demo mobile: interaction", "Collaborate from anywhere : Achieve more together", type);
                    return;
                case "final":
                    sendPostMessage("Google workspace demo mobile: interaction", " Collaborate from anywhere : Call to action", type);
                    return;

            }
        }
    };
    const updatePart = useCallback((part: string, scene: string) => {


        if (part !== "") {
            if (nextScene.current) {
                nextScene.current.className = "nextScene hidden";
            }
            switch (part) {
                case "part1": {
                    setPart("part1");

                    break;
                }
                case "part2": {
                    setPart("part2");

                    break;
                }
                case "part3": {
                    setPart("part3");

                    break;
                }
                case "part3 final": {
                    setPart("part3 final");

                    break;
                }
            }

            const video = getVideo(part, scene);
            if (video) {
                if (players && players.player1 && players.player2 && players.player3) {
                    document.getElementById(players.player1.id())?.parentElement?.classList.add("hidden");
                    document.getElementById(players.player2.id())?.parentElement?.classList.add("hidden");
                    document.getElementById(players.player3.id())?.parentElement?.classList.add("hidden");
                }

                if (players && players.player1 && players.player2 && players.player3) {
                    players.player1.off("timeupdate");
                    players.player2.off("timeupdate");
                    players.player3.off("timeupdate");
                    videoProgress.current.progress(0);
                }

                video.on("loadedmetadata", () => {

                    document.getElementById(video.id())?.parentElement?.classList.remove("hidden");
                    video.off("loadedmetadata");
                })
                video.on("timeupdate", () => {
                    if (playPauseTrigger.current) {
                        if (playPauseTrigger.current.className.indexOf("active") !== -1) {
                            if (players && players.player1 && players.player2 && players.player3) {
                                players.player1.pause();
                                players.player2.pause();
                                players.player3.pause();
                            }
                        }
                    }
                    if (isNaN(videoProgress.current.progress())) {
                        videoProgress.current = gsap.timeline({
                            useFrames: true, paused: true, repeat: 0, ease: "none"
                        }).fromTo([act1Progress.current, act2Progress.current, act3Progress.current], {
                            drawSVG: "0%"
                        }, {
                            drawSVG: "100%",
                            duration: 100
                        }, 0);
                    }
                    document.getElementById(video.id())?.parentElement?.classList.remove("hidden");
                    videoProgress.current.progress(video.currentTime() / video.duration());
                    if (video.currentTime() / video.duration() === 1) {
                        if (part === "part1") {
                            updatePart("part2", scene);
                        } else if (part === "part2") {
                            updatePart("part3", scene);
                        } else if (part === "part3") {
                            if (scene === "collaborate") {
                                updatePart("part3 final", scene);
                            } else {
                                if (nextScene.current) {
                                    nextScene.current.className = "nextScene active";
                                }
                            }
                        }
                        trackVideoChange(part, scene, "autoplay");
                    }
                });

                video.play();
                setActiveVideo(video);

            } else {
            }
            setTimeout(() => {
                setGoingToPart(-1);
                setMenuClick(-1);
            }, 500)
        }
    }, [players, getVideo, setGoingToPart, setMenuClick, setActiveVideo]);


    const updateScene = useCallback((origin: any, destination: any, direction: string) => {
        if (goingToPart === destination.index) {
            return false;
        }
        setGoingToPart(destination.index);
        if (menuClick === -1) {

            if (origin.isFirst && direction === "up") {
                // on first slide, check if we need to go up in parts
                if (part === "part3") {
                    updatePart("part2", scene)
                    trackVideoChange("part2", scene, "in-page interaction");
                } else if (part === "part2" || part === "part1") {
                    updatePart("part1", scene)
                    trackVideoChange("part1", scene, "in-page interaction");
                }
                return false;
            }
            if (origin.isLast && direction === "down") {
                // on last slide, check if we need to go down in parts
                if (part === "part3") {
                    // the end
                    updatePart("part3 final", scene)
                    trackVideoChange("final", scene, "in-page interaction");
                } else if (part === "part1") {
                    updatePart("part2", scene)
                    trackVideoChange("part2", scene, "in-page interaction");
                } else if (part === "part2") {
                    updatePart("part3", scene)
                    trackVideoChange("part3", scene, "in-page interaction");
                }
                return false;
            }
            if (part !== "part3" && direction === "down") {
                if (part === "part1") {
                    updatePart("part2", scene)
                    trackVideoChange("part2", scene, "in-page interaction");
                } else if (part === "part2") {
                    updatePart("part3", scene)
                    trackVideoChange("part3", scene, "in-page interaction");
                }
                return false;
            }
            if (part !== "part1" && direction === "up") {
                if (part === "part3") {
                    updatePart("part2", scene)
                    trackVideoChange("part2", scene, "in-page interaction");
                } else if (part === "part2") {
                    updatePart("part1", scene)
                    trackVideoChange("part1", scene, "in-page interaction");
                }
                return false;
            }
        }

        switch (destination.index) {
            case 0:
                setScene("connect");

                if (direction === "up") {
                    if (menuClick > -1) {
                        updatePart("part1", "connect");
                        trackVideoChange("part1", "connect", "in-page interaction");
                    } else {
                        updatePart("part3", "connect");
                        trackVideoChange("part3", "connect", "in-page interaction");
                    }
                }
                if (direction === "down") {
                    updatePart("part1", "connect");
                    trackVideoChange("part1", "connect", "in-page interaction");
                }
                if (windowDimensions.width <= menuWidth && nodeRef.current) {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px) translate(0px, 0px)`,
                        duration: 0.5
                    });
                }
                break;
            case 1:

                setScene("create");

                if (direction === "up") {
                    if (menuClick > -1) {
                        updatePart("part1", "create");
                        trackVideoChange("part1", "create", "in-page interaction");
                    } else {
                        updatePart("part3", "create");
                        trackVideoChange("part3", "create", "in-page interaction");
                    }
                }
                if (direction === "down") {
                    updatePart("part1", "create");
                    trackVideoChange("part1", "create", "in-page interaction");
                }
                if (windowDimensions.width <= menuWidth && nodeRef.current) {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px) translate(${middleBound}px, 0px)`,
                        duration: 0.5
                    });
                }
                break;
            case 2:

                setScene("collaborate");

                if (direction === "up") {
                    if (menuClick > -1) {
                        updatePart("part1", "collaborate");
                        trackVideoChange("part1", "collaborate", "in-page interaction");
                    } else {
                        updatePart("part3", "collaborate");
                        trackVideoChange("part3", "collaborate", "in-page interaction");
                    }
                }

                if (direction === "down") {
                    updatePart("part1", "collaborate");
                    trackVideoChange("part1", "collaborate", "in-page interaction");
                }
                if (windowDimensions.width <= menuWidth && nodeRef.current) {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px) translate(${leftBound}px, 0px)`,
                        duration: 0.5
                    });
                }
                break;
            default:
                break;

        }

    }, [goingToPart, initialLeft, leftBound, menuClick, middleBound, part, scene, setScene, updatePart, windowDimensions.width]);



    useEffect(() => {
        if (windowDimensions.width > 0) {
            setInitialLeft(windowDimensions.width > menuWidth ? (windowDimensions.width - menuWidth) / 2 : (windowDimensions.width - 195) / 2);
            setLeftBound(windowDimensions.width > menuWidth ? 0 : windowDimensions.width - menuWidth - ((windowDimensions.width - 215)));
            setMiddleBound(-183);
            if (scene === "chat") {
                setScene("loading");
            }
        }

        if (windowDimensions.width < 768) {
            setMenuHeight(56);
            setMarginHeight(8);

        } else if (windowDimensions.width >= 768 && windowDimensions.width < 1440 && windowDimensions.height >= 653) {
            setMenuHeight(128);
            setMarginHeight(8);
        } else {
            setMenuHeight(64);
            setMarginHeight(8);
        }
        document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
    }, [windowDimensions.width, windowDimensions.height, setScene, scene, menuHeight, marginHeight]);



    useEffect(() => {
        if (nodeRef.current) {
            if (windowDimensions.width >= menuWidth) {
                gsap.fromTo(nodeRef.current, {
                    transform: nodeRef.current.style.transform,
                    duration: 0.5
                }, {
                    transform: `translate(${initialLeft}px, 0px)`,
                    duration: 0.5
                });
            } else {
                if (scene === "connect") {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px) translate(0px, 0px)`,
                        duration: 0.5
                    });
                } else if (scene === "create") {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px) translate(${middleBound}px, 0px)`,
                        duration: 0.5
                    });
                } else if (scene === "collaborate") {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px) translate(${leftBound}px, 0px)`,
                        duration: 0.5
                    });
                } else {
                    gsap.fromTo(nodeRef.current, {
                        transform: nodeRef.current.style.transform,
                        duration: 0.5
                    }, {
                        transform: `translate(${initialLeft}px, 0px)`,
                        duration: 0.5
                    });
                }
            }
        }
    }, [windowDimensions.width, initialLeft, leftBound, middleBound, scene]);

    const onStop = (e: DraggableEvent, data: DraggableData) => {
        if (Math.abs(dragStartX - data.x) <= 1) {
            //click event
            if (e.target) {
                e.target.dispatchEvent(new MouseEvent("click", {
                    bubbles: true,
                    cancelable: true
                }));
            }
        }
    }

    const onDragStart = (e: DraggableEvent, data: DraggableData) => {
        setDragStartX(data.x);
    }

    useEffect(() => {
        if (fullpageapi && menuClick >= 0) {
            fullpageapi.moveTo(menuClick);
        }
    }, [menuClick, fullpageapi]);

    useEffect(() => {
        if (gotoScene !== "") {
            switch (gotoScene) {
                case "scene1OpeningAni": {
                    updatePart("part1", "connect");
                    setMenuClick(1);
                    setScene("connect");
                    break;
                }
                case "scene1Act1Ani": {
                    updatePart("part1", "connect");
                    setMenuClick(1);
                    setScene("connect");

                    break;
                }
                case "scene2OpeningAni": {

                    updatePart("part1", "create");
                    setMenuClick(2);
                    break;
                }
                case "scene3OpeningAni": {

                    updatePart("part1", "collaborate");
                    setMenuClick(3);
                    break;
                }
            }
            setGotoScene("");
        }

    }, [gotoScene, fullpageapi, scene, setScene, setMenuClick, updatePart, setGotoScene]);

    const touchEndHandler = (ev: any) => {
        if (scene === "loading") {
            setScene("connect");
            updatePart("part1", "connect");
        }
    };


    const playOn = () => {
        if (scene === "connect") {
            setGotoScene("scene2OpeningAni");
        } else if (scene === "create") {
            setGotoScene("scene3OpeningAni");
        }
        if (nextScene.current) {
            nextScene.current.className = "nextScene hidden";
        }
    };

    useEffect(() => {

        if (ctalinkAni.current) {
            lottie.loadAnimation({
                container: ctalinkAni.current,
                path: './assets/scene1/Loading/data.json',
                renderer: "svg",
                loop: true,
                autoplay: true
            });
        }
        if (act1Player.current && act2Player.current && act3Player.current) {
            let player1 = videojs(act1Player.current, {
                autoplay: true,
                controls: true,
                muted: true,
                poster: "./assets/videos/Act1/Poster.jpg",
                aspectRatio: "1230:776",
                bigPlayButton: true,
                sources: [{
                    src: 'https://kstatic.googleusercontent.com/files/28c64dd86bb1c3762e25cfa152643b34a5130d28daca0d917ded80a62d8045e6205bd59b5faf57f1480bc1fdf699de0c2de9213c4d476fdce71ae8dc22369850',
                    type: 'video/mp4'
                }]
            }, function onPlayerReady() {
                var videoJSPlayer = this;

                videoJSPlayer.ready(function () {
                    videoJSPlayer.poster("./assets/videos/Act1/Poster.jpg");
                    document.getElementById(videoJSPlayer.id())?.setAttribute('poster', "./assets/videos/Act1/Poster.jpg");
                });
            });
            let player2 = videojs(act2Player.current, {
                autoplay: true,
                controls: true,
                muted: true,
                bigPlayButton: true,
                sources: [{
                    src: 'https://kstatic.googleusercontent.com/files/daeb06e95c033dfcd2781e6172a04c8292ba2b35a11ef3d4eedcc87815993d2b8df55e23ccdc24865abb836620a76f604661267e94ed739b10bb5b91bbc5af16',
                    type: 'video/mp4'
                }],
                poster: "./assets/videos/Act2/Poster.jpg",
                aspectRatio: "1230:776"

            }, function onPlayerReady() {
                var videoJSPlayer = this;

                videoJSPlayer.ready(function () {
                    videoJSPlayer.poster("./assets/videos/Act2/Poster.jpg");
                    document.getElementById(videoJSPlayer.id())?.setAttribute('poster', "./assets/videos/Act2/Poster.jpg");
                });
            });
            let player3 = videojs(act3Player.current, {
                autoplay: true,
                controls: true,
                muted: true,
                bigPlayButton: true,
                sources: [{
                    src: 'https://kstatic.googleusercontent.com/files/69e1f1cb133a8bdcc042918ac1390eb8667880da6a4009931435254090c2bb8150634ffbe711d3ee4b5f19ead1059e6ba9eda1ccc0656d0685a1dff340b798cc',
                    type: 'video/mp4'
                }],
                poster: "./assets/videos/Act3/Poster.jpg",
                aspectRatio: "1230:776"
            }, function onPlayerReady() {
                var videoJSPlayer = this;

                videoJSPlayer.ready(function () {
                    videoJSPlayer.poster("./assets/videos/Act3/Poster.jpg");
                    document.getElementById(videoJSPlayer.id())?.setAttribute('poster', "./assets/videos/Act3/Poster.jpg");
                });
            });

            setPlayers({ player1: player1, player2: player2, player3: player3 });
            videoProgress.current = gsap.timeline({ useFrames: true, paused: true, repeat: 0, ease: "none" }).fromTo([act1Progress.current, act2Progress.current, act3Progress.current], {
                drawSVG: "0%"
            }, {
                drawSVG: "100%",
                duration: 100
            }, 0);
            if (playPauseTrigger.current) {
                playPauseTrigger.current.className = "playPauseHolder";
            }
            player1.play();
        }
    }, []);


    return (
        <>
            <div className={"gws-mobile " + (windowDimensions.width >= 768 && windowDimensions.height >= 653 ? "tablet" : "") + (windowDimensions.width > windowDimensions.height && windowDimensions.width <= 1300 ? " landscape" : "")} >
                <div className="gws-mobile--menu">
                    <Draggable axis="x" nodeRef={nodeRef} positionOffset={{ x: initialLeft, y: 0 }} bounds={{ left: leftBound, right: 0 }} onStop={onStop} onStart={onDragStart}>
                        <div className="gws-mobile--slider" ref={nodeRef}>
                            <Menu />
                        </div>
                    </Draggable>
                </div>
                <div className={"act1 " + scene + " " + part} onTouchEnd={touchEndHandler} >

                    <div className="crop" ref={scenesRef} style={{ overflow: scene !== "loading" ? "scroll" : "hidden" }}>
                        <div className={getScreenClass("playPauseHolder")} ref={playPauseTrigger} onClick={() => {
                            if (playPauseTrigger.current) {
                                if (playPauseTrigger.current.className.indexOf("active") === -1) {
                                    playPauseTrigger.current.className = getScreenClass("playPauseHolder active");
                                    setClearPauseTimeout(setTimeout(() => {
                                        if (playPauseTrigger.current) {
                                            playPauseTrigger.current.className = getScreenClass("playPauseHolder");
                                        }
                                    }, 2000))
                                } else if (playPauseTrigger.current.className.indexOf("pause") === -1) {
                                    if (clearPauseTimeout) {
                                        clearTimeout(clearPauseTimeout);
                                    }
                                    playPauseTrigger.current.className = getScreenClass("playPauseHolder active pause");
                                    if (players) {
                                        if (!players.player1.paused()) {
                                            setActiveVideo(players.player1);
                                        }
                                        if (!players.player2.paused()) {
                                            setActiveVideo(players.player2);
                                        }
                                        if (!players.player3.paused()) {
                                            setActiveVideo(players.player3);
                                        }
                                        players.player1.pause();
                                        players.player2.pause();
                                        players.player3.pause();
                                    }
                                } else if (playPauseTrigger.current.className.indexOf("pause") !== -1) {
                                    if (clearPauseTimeout) {
                                        clearTimeout(clearPauseTimeout);
                                    }
                                    playPauseTrigger.current.className = getScreenClass("playPauseHolder");
                                    if (activeVideo) {
                                        activeVideo.play();
                                    }
                                }
                            }


                        }} >
                            <img className="playButton" src="./assets/play.svg" alt="play"></img>
                            <img className="pauseButton" src="./assets/pause.svg" alt="pause" ></img>
                        </div>
                        <button className="restart" onClick={(ev) => {
                            ev.preventDefault();
                            sendPostMessage("Google workspace demo mobile: footer", "restart tour", "in-page interaction");
                            setGotoScene("scene1Act1Ani");
                        }}>
                            <svg width="162" height="81" viewBox="0 0 162 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="81" cy="81" r="81" fill="white" />
                                <path d="M86.7082 19.2918C85.4999 18.0835 83.8416 17.3335 81.9999 17.3335C78.3166 17.3335 75.3416 20.3168 75.3416 24.0002C75.3416 27.6835 78.3166 30.6668 81.9999 30.6668C85.1082 30.6668 87.6999 28.5418 88.4416 25.6668H86.7082C86.0249 27.6085 84.1749 29.0002 81.9999 29.0002C79.2416 29.0002 76.9999 26.7585 76.9999 24.0002C76.9999 21.2418 79.2416 19.0002 81.9999 19.0002C83.3832 19.0002 84.6166 19.5752 85.5166 20.4835L82.8332 23.1668H88.6666V17.3335L86.7082 19.2918Z" fill="#5F6368" />
                            </svg>
                            <span>Restart tour</span>
                        </button>
                        <button className="nextScene hidden" ref={nextScene} onClick={(ev) => {
                            ev.preventDefault();
                            ev.currentTarget.blur();

                            sendPostMessage("Google workspace demo mobile: continue", scene === "connect" ? "Create in real time" : "Collaborate from anywhere", "in-page interaction");

                            playOn();
                        }}>
                            <svg width="162" height="81" viewBox="0 0 162 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="81" cy="81" r="81" fill="white" />
                                <path d="M87.6663 28.9997L86.4913 27.8247L81.833 32.4747V22.333H80.1663V32.4747L75.5163 27.8163L74.333 28.9997L80.9997 35.6663L87.6663 28.9997Z" fill="#5F6368" />
                            </svg><span>Continue</span>
                        </button>

                        <ReactFullpage
                            continuousVertical={true}
                            licenseKey={'36E2BC98-26DE445C-ABE55AC2-2C2DE1BB'}
                            scrollingSpeed={500}
                            onLeave={updateScene}
                            paddingBottom="8px"
                            render={({ state, fullpageApi }) => {
                                return (<ReactFullpage.Wrapper>
                                    <div className="section " onLoad={() => { setFullpageApi(fullpageApi); }}>
                                        <div className="crop cropact1">
                                            <h1 ref={heading}>See how it’s done with Google Workspace</h1>
                                            <a className="ctalink" href="#connect" ref={ctalink} onClick={(ev) => {
                                                ev.preventDefault();

                                                sendPostMessage("Google workspace demo mobile: hero", "take the tour", "in-page interaction");
                                                trackVideoChange("part1", "connect", "in-page interaction");
                                                setScene("connect");
                                            }}><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="16" cy="16" r="15" stroke="#1A73E8" strokeWidth="2" />


                                                </svg>
                                                <span ref={ctalinkAni}></span>
                                            </a>
                                            <img className="icons" ref={icons} src="./assets/scene1/icons.svg" alt="Icons"></img>
                                            <div className={getScreenClass("screen")}>
                                                <video ref={act1Player} className="vjs-default-skin video-js" playsInline={true}></video>

                                            </div>

                                            <h2 className="part1h2">Connect<br />distributed teams</h2>
                                            <h2 className="part2h2">Empower everyone<br />to contribute</h2>
                                            <h2 className="part3h2">Get on the<br />same page</h2>
                                            <img className="clock" ref={clock} src="./assets/scene1/clock.png" alt="Clock"></img>
                                            <img className="mug" ref={mug} src="./assets/scene1/mug.png" alt="Mug"></img>
                                            <img className="plant" ref={plant} src="./assets/scene1/plant.png" alt="Plant"></img>
                                            <img className="book" ref={book} src="./assets/scene1/book.png" alt="Book"></img>
                                            <img className="pens" ref={pens} src="./assets/scene1/pen.png" alt="Pens"></img>
                                            <div className="desk" ref={desk}></div>

                                            <div className="subnav">
                                                <svg width="28" height="97" viewBox="0 0 28 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4" d="M0 0C15.464 0 28 12.536 28 28V69C28 84.464 15.464 97 0 97V0Z" fill="white" />
                                                    <ellipse cx="12.167" cy="27.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                    <ellipse cx="12.167" cy="47.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                    <ellipse cx="12.167" cy="67.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                </svg>
                                                <svg className="progress" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">

                                                    <ellipse cx="6" cy="6" rx="3.5" ry="3.5" fill="#efefee" />
                                                    <circle cx="6" cy="6" r="4" stroke="#BDC1C6" strokeWidth="2"></circle>
                                                    <circle cx="6" cy="6" r="4" stroke="#202124" strokeWidth="2" ref={act1Progress} transform="rotate(-90) translate(-12)"></circle>
                                                </svg>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="section ">
                                        <div className="crop cropact2">
                                            <div className={getScreenClass("screen hidden")}>
                                                <video ref={act2Player} className="vjs-default-skin video-js" playsInline={true}></video>

                                            </div>

                                            <h2 className="part1h2">Share rich<br />content remotely</h2>
                                            <h2 className="part2h2">Give everyone<br />a voice</h2>
                                            <h2 className="part3h2">Organize <br />next steps</h2>
                                            <img className="notebook" ref={notebook} src="./assets/scene2/notebook.png" alt="Notebook"></img>
                                            <img className="headphones" ref={headphones} src="./assets/scene2/headphones.png" alt="Headphones"></img>

                                            <div className="subnav">
                                                <svg width="28" height="97" viewBox="0 0 28 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4" d="M0 0C15.464 0 28 12.536 28 28V69C28 84.464 15.464 97 0 97V0Z" fill="white" />
                                                    <ellipse cx="12.167" cy="27.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                    <ellipse cx="12.167" cy="47.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                    <ellipse cx="12.167" cy="67.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                </svg>
                                                <svg className="progress" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">

                                                    <ellipse cx="6" cy="6" rx="3.5" ry="3.5" fill="#efefee" />
                                                    <circle cx="6" cy="6" r="4" stroke="#BDC1C6" strokeWidth="2"></circle>
                                                    <circle cx="6" cy="6" r="4" stroke="#202124" strokeWidth="2" ref={act2Progress} transform="rotate(-90) translate(-12)"></circle>
                                                </svg>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="section">
                                        <div className="crop cropact3">

                                            <div className={getScreenClass("screen hidden")}>
                                                <video ref={act3Player} className="vjs-default-skin video-js" playsInline={true}></video>

                                            </div>


                                            <h2 className="part1h2">Stay on task<br />across devices</h2>
                                            <h2 className="part2h2">Work with all<br />file types</h2>
                                            <h2 className="part3h2">Achieve more<br />together</h2>
                                            <img className="egg" ref={egg} src="./assets/scene3/egg.png" alt="Egg"></img>
                                            <img className="tablenumber" ref={tablenumber} src="./assets/scene3/tablenumber.png" alt="tablenumber"></img>
                                            <img className="clock" ref={clock} src="./assets/scene1/clock.png" alt="Clock"></img>
                                            <img className="mug" ref={mug} src="./assets/scene1/mug.png" alt="Mug"></img>
                                            <img className="plant" ref={plant} src="./assets/scene1/plant.png" alt="Plant"></img>
                                            <img className="book" ref={book} src="./assets/scene1/book.png" alt="Book"></img>
                                            <img className="pens" ref={pens} src="./assets/scene1/pen.png" alt="Pens"></img>
                                            <div className="desk" ref={desk}></div>
                                            <img className="icons" ref={icons} src="./assets/scene1/icons.svg" alt="Icons"></img>

                                            <h1>Connect, create, and collaborate with your team</h1>
                                            <div className="buttons">
                                                <a href="https://workspace.google.com/intl/en_au/contact/?source=gafb-contact-globalnav-en-AU" className="get-in-touch" >Get in touch to learn how it's done</a>
                                            </div>
                                            <img className="frame1" src="./assets/scene3/frame1.png" alt="frame1"></img>
                                            <img className="frame2" src="./assets/scene3/frame2.png" alt="frame2"></img>
                                            <img className="frame3" src="./assets/scene3/frame3.png" alt="Frame3"></img>

                                            <div className="subnav">
                                                <svg width="28" height="97" viewBox="0 0 28 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4" d="M0 0C15.464 0 28 12.536 28 28V69C28 84.464 15.464 97 0 97V0Z" fill="white" />
                                                    <ellipse cx="12.167" cy="27.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                    <ellipse cx="12.167" cy="47.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                    <ellipse cx="12.167" cy="67.1667" rx="3.5" ry="3.5" fill="#9AA0A6" />
                                                </svg>
                                                <svg className="progress" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <ellipse cx="6" cy="6" rx="3.5" ry="3.5" fill="#efefee" />
                                                    <circle cx="6" cy="6" r="4" stroke="#BDC1C6" strokeWidth="2"></circle>
                                                    <circle cx="6" cy="6" r="4" stroke="#202124" strokeWidth="2" ref={act3Progress} transform="rotate(-90) translate(-12)"></circle>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </ReactFullpage.Wrapper>
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )

}

export default MobileView;
